import {
  SYNDICATION_FEED,
  SYNDICATION_PRIVACY,
} from "../../../../constants/v2/createWantAd";
import { WANT_AD_KEY, WANT_AD_KEY_TEMP } from "../../../../constants/common";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../../helpers/v2/common";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import MobileDropdownSelect from "../../../components/MobileDropdownSelect";
import PremiumFeatureStar from "../../../../images/v2/premium-features-stars.svg";
import { pageURLs } from "../../../../constants/v2/pageURLs";
function AddSyndication({ handleFormValues, wantAdData, isDisabled }) {
  const navigate = useNavigate();
  const handleDropdownClick = () => {
    if (isDisabled) {
      navigate(pageURLs.updatePlan, {
        state: {
          isFromSettings: true,
          UpgradeToAgent: true,
        },
      });
    }
  };

  return (
    <>
      <div>
        <div className="inner-layout-content-new bg-white pl-16 pr-16 pb-0 position-relative">
          <div className="top-three-comp-btm-sec mt-0 pt-3 pb-4">
            <h6 className="">Want Listing Syndication</h6>
          </div>
        </div>
        <Card className="mb-0 border-0 want-listing-syndication">
          <Card.Body className="pl-16 pr-16 pb-16 border-0 card-header want-listing">
            <div className="row g-3">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="text-muted want-listing-wrapper__label">
                    <div
                      className="d-flex align-items-center"
                      onClick={() => {
                        if (isDisabled) {
                          navigate(pageURLs.updatePlan, {
                            state: {
                              isFromSettings: true,
                              UpgradeToAgent: true,
                            },
                          });
                        }
                      }}
                    >
                      Feed
                      {isDisabled ? (
                        <div
                          style={{ margin: "2px 5px" }}
                          onClick={() => {
                            navigate(pageURLs.updatePlan, {
                              state: {
                                isFromSettings: true,
                                UpgradeToAgent: true,
                              },
                            });
                          }}
                        >
                          <img src={PremiumFeatureStar} alt="Premium Star" />
                        </div>
                      ) : null}
                    </div>
                  </Form.Label>
                  <MobileDropdownSelect
                    className={`${isDisabled ? "disabled-select" : ""}`}
                    onMouseDown={handleDropdownClick}
                    isSearchable={false}
                    value={
                      wantAdData?.syndicationFeed
                        ? {
                            value: wantAdData.syndicationFeed,
                            label: `Display to ${wantAdData.syndicationFeed} feed`,
                          }
                        : {
                            value: "public",
                            label: "Display to public feed",
                          }
                    }
                    onChange={(e) =>
                      handleFormValues({
                        syndicationFeed: e?.value || "public",
                        focusOut: true,
                      })
                    }
                    options={Object.entries(SYNDICATION_FEED).map(
                      ([key, value]) => ({
                        value: value,
                        label: `Display to ${value} feed`,
                      }),
                    )}
                    // disabled={isDisabled}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="text-muted want-listing-wrapper__label">
                    <div
                      className="d-flex align-items-center"
                      onClick={() => {
                        if (isDisabled) {
                          navigate(pageURLs.updatePlan, {
                            state: {
                              isFromSettings: true,
                              UpgradeToAgent: true,
                            },
                          });
                        }
                      }}
                    >
                      Privacy
                      {isDisabled ? (
                        <div
                          style={{ margin: "2px 5px" }}
                          onClick={() => {
                            navigate(pageURLs.updatePlan, {
                              state: {
                                isFromSettings: true,
                                UpgradeToAgent: true,
                              },
                            });
                          }}
                        >
                          <img src={PremiumFeatureStar} alt="Premium Star" />
                        </div>
                      ) : null}
                    </div>
                  </Form.Label>
                  <MobileDropdownSelect
                    className={`${isDisabled ? "disabled-select" : ""}`}
                    onMouseDown={handleDropdownClick}
                    key={Math.random()}
                    isSearchable={false}
                    value={
                      wantAdData?.syndicationPrivacy
                        ? {
                            value: wantAdData.syndicationPrivacy,
                            label: `${wantAdData.syndicationPrivacy} my agent info and contact`,
                          }
                        : {
                            value: "hide",
                            label: "hide my agent info and contact",
                          }
                    }
                    onChange={(e) =>
                      handleFormValues({
                        syndicationPrivacy: e?.value || "hide",
                        focusOut: true,
                      })
                    }
                    options={Object.entries(SYNDICATION_PRIVACY).map(
                      ([key, value]) => ({
                        value: value,
                        label: `${value} my agent info and contact`,
                      }),
                    )}
                    // disabled={isDisabled}
                    onMounseDown={() => {
                      if (isDisabled) {
                        navigate(pageURLs.updatePlan, {
                          state: {
                            isFromSettings: true,
                            UpgradeToAgent: true,
                          },
                        });
                      }
                    }}
                  />
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
}

export default AddSyndication;
